import React from "react";
import { Link } from "react-router-dom";

export default function MobileBookingBar() {
  return (
    <div className="mobile-booking-bar" role="region" aria-label="Quick booking">
      <div className="mobile-booking-inner">
        <Link to="/contact" className="btn-primary mobile-primary">
          Check Availability
        </Link>
        <a href="tel:+15618737499" className="btn-secondary mobile-secondary" aria-label="Call the chef">
          Call
        </a>
      </div>
    </div>
  );
}